<div class="ph-item rounded-2xl">
    <div class="ph-col-12">
        <div class="ph-picture"></div>

    </div>
</div>
